export default __webpack_public_path__ + "static/media/pce.7f46e60b.png";